import React from "react";
import { useFormContext, useController } from "react-hook-form";
import { ColorResult } from "react-color";
import { ColorPill } from "./ColorPill";
import { InputLabel } from "../Inputs";
import { InputErrorMessage } from "components/atoms";

interface PaziaColorPillProps {
  name: string;
  required?: boolean;
  label?: string;
  hideErrors?: boolean;
  className?: string;
  onChange?: (color: ColorResult) => void;
}
export const PaziaColorPill = ({ name, required, label, hideErrors, className, onChange }: PaziaColorPillProps) => {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
  });

  const onChangeHandler = (color: ColorResult) => {
    field.onChange(color.rgb ? `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})` : "");
    if (onChange) onChange(color);
  };

  return (
    <div className={className ?? ""}>
      <InputLabel label={label} required={required} name={name} />
      <ColorPill onChange={onChangeHandler} defaultColor={field.value} />
      {!hideErrors && <InputErrorMessage name={name} />}
    </div>
  );
};
